/*
 * the table width on mobile exceeds the width of its columns
 * and no combination of width, max-width and their allowed CSS values fixes it
 * because reasons
 * so force the width on mobile to the calculated sum of the column widths
 * and unset it on desktop
 */

function sumWidth(total, element) {

    return total + element.offsetWidth;
}

function unsetWidth(table) {
    table.style.removeProperty('width');
}

function setWidth(table, header) {
    const width = [...header.children].reduce(sumWidth, 0);

    table.style.width = width + 'px';
}

function maybeSetWidth(breakpoint, table, header) {

    if (breakpoint.matches) {
        setWidth(table, header);
    } else {
        unsetWidth(table);
    }
}

function init() {
    const table = document.querySelector('.js_oraComparisonTable__table'),
          header = document.querySelector('.js_oraComparisonTable__header');

    if (table && header) {
        const breakpoint = matchMedia('(max-width:670px)');

        breakpoint.addListener(breakpoint => maybeSetWidth(breakpoint, table, header));
        maybeSetWidth(breakpoint, table, header);
    }
}

$(document).ready(init);
